import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { makeServer } from "./server";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/authContext";
import { VideoProvider } from "./context/videoContext";
import { FilterProvider } from "./context/filterContext";

// Call make Server
makeServer();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
 
      <VideoProvider>

        <AuthProvider>
          <FilterProvider>
            <App />
            </FilterProvider>
        </AuthProvider>
       
      </VideoProvider>

    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
